<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <a :href="product.permalink" class="link-opacity block size-24">
    <img :src="product.image_url" class="size-full object-contain" :alt="product.name">
  </a>
</template>
